import {clientSide} from '../../config_react.js';

const {redirectToStorage} = clientSide[0];

export function addFile(file) {
    return {
        type: 'ADD_FILE',
        file,
    };
}

export function removeFile(file) {
    return {
        type: 'REMOVE_FILE',
        file,
    };
}

export function addServices(arr) {
    return {
        type: 'ADD_SERVICES',
        arr,
    };
}

export function addFilesList(obj) {
    return {
        type: 'ADD_FILES_LIST',
        obj,
    };
}

export function addFilesOther(arr) {
    return {
        type: 'ADD_FILES_OTHER',
        arr,
    };
}

export function getServices(address) {
    console.log('/pagetservices:address', address);
    return dispatch => {
        fetch(`${redirectToStorage}/pagetservices`, {
            method: 'GET',
            headers: {
                Cache: 'no-cache',
            },
            credentials: 'include',
        })
            .then(response => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then(response => response.json())
            .then(items => {
                console.log(`return: /pagetservices`)
                console.log(items)
                let itemsArr = JSON.parse(items.services_list);
                if (itemsArr.length > 0) {
                    let arr = [];
                    itemsArr.forEach((item, i) => {
                        arr.push({
                            id: item.eth_address,
                            name: item.firstname,
                        });
                    });
                    dispatch(addServices(arr));
                }
            })
            .catch(err => {
                throw Error(err.message).stack;
            });
    };
}

export function getFiles() {
    return dispatch => {
        fetch(`${redirectToStorage}/pagetfilelist`, {
            method: 'GET',
            headers: {
                Cache: 'no-cache',
            },
            credentials: 'include',
        })
            .then(response => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then(response => response.json())
            .then(items => {
                console.log(`return: /pagetfilelist`)
                console.log(items)
                let itemsArr = items.file_list;
                if (itemsArr.files.length === 0) {
                    dispatch(
                        addFilesList({
                            passport: '',
                            account_statement: '',
                            registration: '',
                            ownership: '',
                        })
                    );
                    dispatch(addFilesOther([]));
                }
                if (itemsArr.files.length > 0) {
                    let arrOther = [];
                    let dataObject = {
                        passport: '',
                        account_statement: '',
                        registration: '',
                        ownership: '',
                    };
                    itemsArr.files.forEach((item) => {
                        if (item.fileType !== 'other') {
                            Object.assign(dataObject, {
                                [item.fileType]: item,
                            });
                        } else {
                            arrOther.push(item);
                        }
                    });
                    dispatch(addFilesList(dataObject));
                    dispatch(addFilesOther(arrOther));
                }
            })
            .catch(err => {
                throw Error(err.message).stack;
            });
    };
}
